import fetch from "../../uilts/request.js";



export default {
    async addSilenceSignSubject(data) {
        return await fetch.post("/FreesonCertification/addSilenceSignSubject", data)
    },

    async submitAddSilenceSignSubject(data) {
        return await fetch.post("/FreesonCertification/submitAddSilenceSignSubject", data)
    },
    async create(data) {
        return await fetch.post("/FreesonCertification/create", data)
    },
    async createOrder(data) {
        return await fetch.post("/FreesonCertification/createOrder", data)
    },
    async getQrInfos(data) {
        return await fetch.post("/FreesonCertification/getQrInfos", data)
    },
    async applyCert(data) {
        return await fetch.post("/FreesonCertification/applyCert", data)
    },
    async getAgreementFileDownloadUrl(data) {
        return await fetch.post("/FreesonCertification/getAgreementFileDownloadUrl", data)
    },
    async getNotarizationDownloadUrl(data) {
        return await fetch.post("/FreesonCertification/getNotarizationDownloadUrl", data)
    },
    async getOrderInfo(data) {
        return await fetch.post("/FreesonCertification/getOrderInfo", data)
    },
    async getAgreement(data) {
        return await fetch.post("/FreesonCertification/getAgreement", data)
    },
}




